(ns pfo.scope.scope
  (:require [pfo.util :as util]))

(def level-family :family)
(def level-subscriber :subscriber)
(def level-global :global)

(defn get-scope [subscriber-id family-id]
  (cond
    family-id {:level level-family :id family-id}
    subscriber-id {:level level-subscriber :id subscriber-id}
    :else {:level level-global}))

(defn scope [level id] {:level level :id id})

(defn to-str [scope] (str (name (:level scope)) ":" (:id scope)))

(defn from-str [scope-str]
  (let [[level id] (clojure.string/split scope-str #":")]
    (scope (keyword level) (util/str->int id))))
